var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-count"},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }